import React from 'react';

/**
 * Reusable Load More Section Component
 * Shows either a "Load More" button or an end message
 * 
 * @param {boolean} hasNextPage - Whether there are more items to load
 * @param {function} onLoadMore - Function to call when Load More is clicked
 * @param {boolean} isLoading - Whether data is currently loading
 * @param {string} loadMoreText - Text for the load more button (default: "Load More")
 * @param {string} endMessage - Message to show when no more items (default: "No more items to load")
 * @param {string} accentColor - Color for button shadow (default: "17, 207, 243")
 * @param {boolean} compact - Use compact padding for scrollable containers (default: false)
 */
export default function LoadMoreSection({
    hasNextPage,
    onLoadMore,
    isLoading = false,
    loadMoreText = "Load More",
    endMessage = "No more items to load",
    accentColor = "17, 207, 243", // RGB values as string
    compact = false // New prop for compact mode
}) {
    return (
        <div className="w-100" style={{ padding: compact ? '10px 0' : '40px 0 20px' }}>
            <center>
                {hasNextPage ? (
                    <button
                        onClick={onLoadMore}
                        disabled={isLoading}
                        style={{
                            width: "auto",
                            minWidth: '220px',
                            padding: '14px 40px',
                            fontSize: '15px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            transition: 'all 0.3s ease',
                            opacity: isLoading ? 0.7 : 1,
                            transform: isLoading ? 'scale(0.98)' : 'scale(1)',
                            boxShadow: isLoading
                                ? 'none'
                                : `0 4px 14px rgba(${accentColor}, 0.25)`,
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            margin: '0 auto'
                        }}
                        className="btn BtnBlack"
                    >
                        {isLoading ? (
                            <>
                                <div style={{
                                    width: '18px',
                                    height: '18px',
                                    border: '3px solid rgba(255, 255, 255, 0.3)',
                                    borderTop: '3px solid #fff',
                                    borderRadius: '50%',
                                    animation: 'spin 0.8s linear infinite'
                                }} />
                                <span>Loading...</span>
                            </>
                        ) : (
                            <>
                                <span>{loadMoreText}</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </>
                        )}
                    </button>
                ) : (
                    <p style={{
                        color: '#9ca3af',
                        fontSize: '14px',
                        fontWeight: '500',
                        margin: 0,
                        textAlign: 'center'
                    }}>
                        {endMessage}
                    </p>
                )}
            </center>
        </div>
    );
}

